import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  EnergyRevenuesListItem,
  GetEnergyRevenuesTableColumnParams
} from "../../../RevenueMonitoring.types";
import { getAufwandsersatzRedispatchColumn } from "../columns/getAufwandsersatzRedispatchColumn";
import { getAusfallarbeitDvaColumn } from "../columns/getAusfallarbeitDvaColumn";
import { getAusfallarbeitFoerderungRedispatchColumn } from "../columns/getAusfallarbeitFoerderungRedispatchColumn";
import { getAusfallarbeitRedispatchColumn } from "../columns/getAusfallarbeitRedispatchColumn";
import { getDvaEntgeltColumn } from "../columns/getDvaEntgeltColumn";
import { getRedispatchEntgeltColumn } from "../columns/getRedispatchEntgeltColumn";
import { getRevenueDvaColumn } from "../columns/getRevenueDvaColumn";
import { getRevenueFoerderungRedispatchColumn } from "../columns/getRevenueFoerderungRedispatchColumn";
import { getRevenueRedispatchColumn } from "../columns/getRevenueRedispatchColumn";
import { AUSFALLARBEIT_COLUMN_GROUPS } from "../EnergyRevenuesTable.constants";
export function getAusfallarbeitColumnGroups({
  companyId,
  dataVerificationColumns,
  dataVerificationItems,
  columnVisibility
}: GetEnergyRevenuesTableColumnParams): Array<
  MRT_ColumnDef<EnergyRevenuesListItem>
> {
  return [
    {
      id: "ausfallarbeit_redispatch_direktvermarkter_group",
      header:
        AUSFALLARBEIT_COLUMN_GROUPS
          .ausfallarbeit_redispatch_direktvermarkter_group.label,
      mantineTableHeadCellProps: {
        className: "column-group-header-border-left"
      },
      columns: [
        getAusfallarbeitRedispatchColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility,
          groupName: "ausfallarbeit_redispatch_direktvermarkter_group"
        }),
        getRevenueRedispatchColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        }),
        getRedispatchEntgeltColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        })
      ]
    },
    {
      id: "ausfallarbeit_redispatch_netzbetreiber_group",
      header:
        AUSFALLARBEIT_COLUMN_GROUPS.ausfallarbeit_redispatch_netzbetreiber_group
          .label,
      mantineTableHeadCellProps: {
        className: "column-group-header-border-left"
      },
      columns: [
        getAusfallarbeitRedispatchColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility,
          groupName: "ausfallarbeit_redispatch_netzbetreiber_group"
        }),
        getAufwandsersatzRedispatchColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        }),
        getAusfallarbeitFoerderungRedispatchColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        }),
        getRevenueFoerderungRedispatchColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        })
      ]
    },
    {
      id: "ausfallarbeit_dva_group",
      header:
        "Vermarktungserlös Vermarktungs-Abschaltungen (Abrechnung Vermarkter)",
      mantineTableHeadCellProps: {
        className: "column-group-header-border-left"
      },
      columns: [
        getAusfallarbeitDvaColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        }),
        getRevenueDvaColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        }),
        getDvaEntgeltColumn({
          companyId,
          dataVerificationColumns,
          dataVerificationItems,
          columnVisibility
        })
      ]
    }
  ];
}
